import React from 'react';
import Component from './route-component';
import Enhance from '../core/enhance'
import debug from 'debug';
import $event from "../decorators/$event";

let log = debug('router.route-switch');

/**
 *
 */
class RouteSwitch extends Component {
    
    /**
     *
     * @param props
     */
    constructor(props) {
        super(props)
    }
    
    /**
     * shouldComponentUpdate(object nextProps, object nextState): boolean
     * 当组件做出是否要更新DOM的决定的时候被调用。
     * 实现该函数，优化this.props和nextProps，以及this.state和nextState的比较，
     * 如果不需要React更新DOM，则返回false。
     */
    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }
    
    /**
     *
     * @return {null}
     */
    render() {
        let {type} = this.props;
        let location = this.location();
        let {hash} = location;
        //log('hash=', hash, 'props=', this.props.hash);
        
        //非hash现实
        if (this.props.hash && this.props.hash.startsWith('!')) {
            let check = this.props.hash.substr(1);
            if ('#' + check !== hash) {
                log('show', this.props.hash)
                return <div className="c-route-switch">{this.props.children}</div>
            }
        }
        else if (hash === '#' + this.props.hash || (!hash && this.props.default === true)) {
            log('show', this.props.hash)
            return <div className="c-route-switch">{this.props.children}</div>
        }
        
        if (type === 'active') {
            return <div className="c-route-switch" style={{display: 'none'}}>{this.props.children}</div>;
        } else {
            return <div className="c-route-switch" style={{display: 'none'}}/>;
        }
    }
    
    /**
     *
     * @param data
     * @param type
     */
    @$event('Router.listen')
    handlerRouterListen = (data, type) => {
        //log(data, type)
        if (type === 'REPLACE')
            this.forceUpdate();
    }
    
}

Enhance(RouteSwitch, {}, 'RouteSwitch');
export default RouteSwitch
